import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getUrlParams} from 'modules/search/selectors'
import {setIsMapOpen, setLayout} from 'modules/search/slice'
import {LayoutType} from 'modules/search/types'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

/**
 * Hook used to handle default layout logic
 */
export const useDefaultLayout = () => {
  const dispatch = useDispatch()
  const {isDesktopMd, isDesktopLg} = useDeviceLayout()
  const {search} = useBrandCapabilities()
  const {layout: layoutUrlParam} = useSelector(getUrlParams) || {}

  // Reject invalid URL param values
  const validatedUrlParam =
    layoutUrlParam && Object.values(LayoutType).includes(layoutUrlParam)
      ? layoutUrlParam
      : undefined

  // Default to SPLIT layout on desktop if map view is enabled, otherwise use LIST layout
  const defaultLayout =
    search.hasMap && (isDesktopMd || isDesktopLg)
      ? LayoutType.SPLIT
      : LayoutType.LIST

  const layout = validatedUrlParam || defaultLayout

  const isMapVisible = layout === LayoutType.MAP || layout === LayoutType.SPLIT

  const isListVisible =
    layout === LayoutType.LIST || layout === LayoutType.SPLIT

  // This effect is used to update the layout and map visibility when the layout changes
  // We check if layout is not undefined to avoid setting an invalid value
  useEffect(() => {
    dispatch(setLayout(layout))
    dispatch(setIsMapOpen(isMapVisible))
  }, [dispatch, layout, isMapVisible])

  return {
    layout,
    isListVisible,
    isMapVisible
  }
}
